import { confirmAlert } from 'react-confirm-alert';
import moment from "moment";

const EXPIRES_TODAY = "Expires Today"
const EXPIRES_TOMORROW = "Expires Tomorrow"
const EXPIRES_IN = "Expires in "

export const submit = (message, callback) => {
    confirmAlert({
        message: message,
        buttons: [
            {
                label: 'Yes',
                onClick: () => {
                    callback()
                }
            },
            {
                label: 'No',
                onClick: () => { }
            }
        ]
    });
};

export const alert = (message) => {
    confirmAlert({
        message: message,
        buttons: [
            {
                label: 'OK',
                onClick: () => { }
            }
        ]
    });
};

export const formatDate = (date, zone) => {
    if (date) {
        date = new Date(date);
        if (zone) {
            let newDate = new Date(date.toUTCString()).toLocaleString("en-US", { timeZone: zone });
            date = new Date(newDate);
        }
    }
    return date
}

export const decimalFilter = (value, decimals) => {
    var result = true;
    if (value) {
        var values = value.toString().split(".")
        if (values.length < 2) result = true;
        else if (values[1] != null) result = values[1].length <= decimals
    }
    return result;
}

export const validateTime = (time) => {
    return (!time || time.includes("-") || time.includes("undefined") || time.toLowerCase().includes("nan") || time.toLowerCase().includes("null")) ? "-" : time
}

export const validatePhone = (phone) => {
    return (!phone || phone.includes("undefined") || phone.toLowerCase().includes("nan") || phone.toLowerCase().includes("null")) ? "" : phone
}

export const formatNumber = (number) => {
    if (number == null || typeof number !== 'number')
        return null
    var parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

export const dateDiffInDays = (fromDate, toDate) => {
    if (!fromDate || !toDate)
        return null;
    const MS_PER_DAY = 1000 * 60 * 60 * 24;
    return Math.ceil((moment(toDate) - moment(fromDate)) / MS_PER_DAY);
}

export const sortArrayByGivenKey = (array, key, ascending) => {
    if (!array || array.length <= 0) return []
    let sortFunction = (a, b) => 0
    if (typeof array[0][key] === "number") {
        sortFunction = (a, b) => ((a[key] - b[key]) * (ascending ? 1 : -1))
    } else if (typeof array[0][key] === "string") {
        sortFunction = (a, b) => {
            if (a[key] < b[key]) { return ascending ? -1 : 1 }
            if (a[key] > b[key]) { return ascending ? 1 : -1 }
            return 0;
        }
    } else if (typeof array[0][key] === "boolean") {
        sortFunction = (a, b) => (a[key] == b[key] ? 0 : a[key] == ascending ? -1 : 1)
    }
    array.sort(sortFunction)
    return array
}

/**
 * Format the time to display in the page.
 * @param {date} date the date object in string.
 * @param {string} zone the timezone in string.
 */
export const formatTime = (date, zone) => {
    if (date) {
        date = formatDate(date, zone)
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    } else {
        return null;
    }
}

export const getExpiryDuration = (toDate) => {
    let dateDiffersInDays = dateDiffInDays(new Date().toDateString(), moment(toDate).format('YYYY MM DD'));
    const dayCount = dateDiffersInDays == null ? "--" : dateDiffersInDays;
    switch (dayCount) {
        case 0: {
            return EXPIRES_TODAY;
        }
        case 1: {
            return EXPIRES_TOMORROW;
        }
        default:
            return EXPIRES_IN + dayCount + " Days";
    }
}

export const sortDataByDate = (data) => {
    return data.sort((a, b) => {
        return new Date(b.to) - new Date(a.to);
    });
}

export const sortDataByDateWithNullFirst = (data) => {
    return data.sort((a, b) => {
        if (!a.to || !b.to)
            return true;
        return new Date(b.to) - new Date(a.to);
    });
}

export const isValidUrl = (url) => {
    return /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi.test(url);
}

export const isValidAlphaNumeric = (text) => {
    return /^[0-9a-zA-Z]+$/.test(text);
}

export const isValidEmail = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}